import styled from "@emotion/styled";
export const BodyPartItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  border-radius: 10px;
  box-shadow: 0px 3px 19px -11px rgba(30, 33, 95, 1);
  padding: 5px 10px;
`;
